import React from 'react';
import { Link } from 'react-router-dom';

function ChamadoHeader({ titulo, subtitulo, solicitanteNome, statusNome, prioridadeBadge, sprintNome, sprintId, tipoNome, atendenteNome, iaHabilitada, onSugerirPrioridade, prioridadeLoading, onAlterarTipo, actionsRight }) {
    const nomeAte = (atendenteNome || '').toString().trim();
    const nomeSol = (solicitanteNome || '').toString().trim();
    const sprintLabel = sprintId ? (sprintNome && sprintNome.trim() ? sprintNome : `Sprint #${sprintId}`) : null;
    return (
        <header className="chamado-header">
            <h1 className="chamado-header-titulo">{titulo}</h1>
            {(subtitulo || nomeAte || nomeSol) && (
                <h2 className="chamado-header-subtitulo chamado-header-subtitulo-row">
                    {subtitulo && <span>{subtitulo}</span>}
                    {nomeAte && <span className="chamado-header-atendente">{nomeAte}</span>}
                    {nomeSol && <span className="chamado-header-solicitante" title="Solicitante">Solicitante: {nomeSol}</span>}
                </h2>
            )}
            <div className="chamado-header-badges-row">
                <div className="chamado-header-badges">
                    {statusNome && <span className="chamado-badge chamado-badge-status">{statusNome}</span>}
                    {prioridadeBadge != null && prioridadeBadge !== '' && <span className="chamado-badge chamado-badge-prioridade">{prioridadeBadge}</span>}
                    {iaHabilitada && (
                        <button type="button" className="chamado-header-btn-ia" onClick={onSugerirPrioridade} disabled={prioridadeLoading} title="IA sugere prioridade">
                            {prioridadeLoading ? 'Analisando...' : 'Sugerir prioridade (IA)'}
                        </button>
                    )}
                    {sprintId && (
                        <Link to={`/sprint?sprint=${sprintId}`} className="chamado-badge chamado-badge-sprint chamado-badge-sprint-link" title="Ir para a sprint">
                            {sprintLabel}
                        </Link>
                    )}
                    {tipoNome && (
                        onAlterarTipo ? (
                            <button type="button" className="chamado-badge chamado-badge-tipo chamado-badge-tipo-clickable" onClick={onAlterarTipo} title="Alterar tipo do chamado">
                                {tipoNome} <i className="fas fa-pencil-alt chamado-badge-tipo-icon" aria-hidden="true" />
                            </button>
                        ) : (
                            <span className="chamado-badge chamado-badge-tipo">{tipoNome}</span>
                        )
                    )}
                </div>
                {actionsRight && <div className="chamado-header-actions-right">{actionsRight}</div>}
            </div>
        </header>
    );
}

export default ChamadoHeader;
